const UNSAFE_KEYS = ["__proto__", "constructor", "prototype"];
const isMergeable = (value) => {
  if (Array.isArray(value)) {
    return true;
  }
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
};
const mergeInto = (target, source) => {
  for (const key of Object.keys(source)) {
    if (UNSAFE_KEYS.includes(key)) {
      continue;
    }
    const sourceValue = source[key];
    if (sourceValue === void 0) {
      continue;
    }
    const targetValue = target[key];
    if (isMergeable(sourceValue)) {
      if (isMergeable(targetValue) && Array.isArray(targetValue) === Array.isArray(sourceValue)) {
        mergeInto(targetValue, sourceValue);
      } else {
        const fresh = Array.isArray(sourceValue) ? [] : {};
        mergeInto(fresh, sourceValue);
        target[key] = fresh;
      }
    } else {
      target[key] = sourceValue;
    }
  }
};
function deepMerge(target, ...sources) {
  for (const source of sources) {
    if (isMergeable(source)) {
      mergeInto(target, source);
    }
  }
  return target;
}
export {
  deepMerge
};
//# sourceMappingURL=deep-merge.js.map
